<div class="display-info-icon" [ngClass]="{ 'flex': flex }">
    <mat-icon
        *ngIf="displayIcon.icon"
        [inline]="inline"
        [svgIcon]="displayIcon ? displayIcon.icon : ''"
        [ngClass]="getCls(displayIcon)"
    >
    </mat-icon>
    <mat-icon
        *ngIf="!displayIcon.icon && displayIcon.materialIcon"
        [inline]="inline"
        [ngClass]="getCls(displayIcon)"
    >
        {{displayIcon.materialIcon}}
    </mat-icon>
    <ng-container *ngIf="displayIcon.getSubIcon && displayIcon.getSubIcon()">
        <mat-icon
            *ngIf="displayIcon.getSubIcon().icon"
            [svgIcon]="displayIcon.getSubIcon().icon"
            [ngClass]="getCls(displayIcon.getSubIcon())"
            [inline]="inline"
            class="overlapped-icon"
        >
        </mat-icon>
        <mat-icon
            *ngIf="!displayIcon.getSubIcon().icon && displayIcon.getSubIcon().materialIcon"
            [inline]="inline"
            [ngClass]="getCls(displayIcon.getSubIcon())"
            class="overlapped-icon"
        >
            {{displayIcon.getSubIcon().materialIcon}}
        </mat-icon>
    </ng-container>
</div>
